import BaseLayout from '@layouts/Base/BaseLayout';
import html from './TermsAndConditions.constants';
import { Content, HeaderText } from './TermsAndConditions.styles';
import { TermsAndConditionsProps } from './TermsAndConditions.types';

const TermsAndConditions = ({ user }: TermsAndConditionsProps): JSX.Element => {
  const userName = user ? user.name : undefined;
  return (
    <BaseLayout headerProps={{ userName }} showFooter={true}>
      <HeaderText>Terms &amp; conditions</HeaderText>
      <Content dangerouslySetInnerHTML={{ __html: html }} />
    </BaseLayout>
  );
};

export default TermsAndConditions;
